import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChangeOnePart } from 'amira-intervention-library';
import useEndingSpeech from '../../hooks/useEndingSpeech';
import useDidAttempt from '../../hooks/useDidAttempt';
import usePauseControl from '../../hooks/usePauseControl';
import { phraseTypes } from "../../../../../constants/constants";
import usePhraseTypeIndexes from '../../hooks/usePhraseTypeIndexes';
import { COPY_STRINGS } from '../../../../../constants/translatedCopy';
import { useSelector } from 'react-redux';
import { selectReaderManager } from '../../../ReaderManagerEvents/ReaderManagerSlice';

export default function ChangeOnePartAssessment({ 
    metadata, 
    currentPageIndex, 
    paused, 
    setWillHandlePause, 
    startPhrase, 
    pausePhrase, 
    resumePhrase, 
    doneHandlingPause, 
    transcript }) {

    const { shouldHandlePause, finishHandlePause, passPauseControlBackToReaderManager } = usePauseControl({
        paused,
        setWillHandlePause,
        pausePhrase,
        resumePhrase,
        doneHandlingPause
    })

    const readerManagerStates = useSelector(selectReaderManager)
    const { contextStates: { minTimeElapsed } } = readerManagerStates;

    const { addToEndingSequence, hasPendingEndingSequence } = useEndingSpeech()

    const { didAttempt } = useDidAttempt({transcript})

    const {
        isExamplePhraseOfThisType,
        isLastPhraseOfThisType,
        currentPhraseIndexOfThisType,
        isLastPageOfStory,
    } = usePhraseTypeIndexes(currentPageIndex, phraseTypes.CHANGE_ONE_PART)

    /**
     * assessment handle when there is an attempt by the kid
     */
    useEffect(() => {
        if (didAttempt) {
            registerEndingSpeech()
            passPauseControlBackToReaderManager()
        }
    }, [didAttempt])

    /**
     * assessment register an ending speech for reader manager to play on end of phrase
     */
    const registerEndingSpeech = () => {
        if(isExamplePhraseOfThisType){
            addToEndingSequence({textToSpeak: COPY_STRINGS.intervention_strings.change_one_part.assessment_handle_item_done_try_another})
        }else if(isLastPhraseOfThisType){
            if(isLastPageOfStory){
                addToEndingSequence({textToSpeak: COPY_STRINGS.intervention_strings.change_one_part.end})
            }else{
                addToEndingSequence({textToSpeak: COPY_STRINGS.intervention_strings.change_one_part.end_with_more_activities})
            }
        }
    }

    // add anything that is specific to assessment mode
    const assessmentMetadata = {
        ...metadata,
        handleMessage: (message) => { // basically gives it the full control of the phrase timing
            const { event } = message
            if (event === "start") {
                // after intro
                startPhrase()
            } else if (event === "retry") {
                // clear the phrase timeout so that we can speak without the clock ticking and move to the next phrase during the speech
                finishHandlePause();
                passPauseControlBackToReaderManager()
            }
        }
    }

    const states = {
        paused: paused && shouldHandlePause,
        didAttempt: didAttempt && minTimeElapsed
    }
    
    return <ChangeOnePart {...assessmentMetadata} {...states}/>
}

ChangeOnePartAssessment.propTypes = {
    metadata: PropTypes.object.isRequired,
    currentPageIndex: PropTypes.number.isRequired,
    paused: PropTypes.bool.isRequired,
    setWillHandlePause: PropTypes.func.isRequired,
    startPhrase: PropTypes.func.isRequired,
    pausePhrase: PropTypes.func.isRequired,
    resumePhrase: PropTypes.func.isRequired,
    doneHandlingPause: PropTypes.func.isRequired,
    transcript: PropTypes.object.isRequired,
}